import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	editWorkflow: {
		id: 'polaris-component-field-configuration.decoration.decoration-config-content.status-decoration.edit-workflow',
		defaultMessage: 'Edit workflow',
		description: 'Label for edit workflow button',
	},
});
